export const MEMBER_PROFILE_COPY = {
  BACK_LABEL: 'Back',
  LOAD_ERROR: 'Could not load profile.',
  STAT_LABEL_PTS: 'pts',
  STAT_LABEL_EXACT: 'exact',
  STAT_LABEL_CORRECT: 'correct',
  SECTION_FUTURES: 'Tournament Picks',
  SECTION_MATCHES: 'Match Picks',
  EMPTY_MATCHES: 'No finished or live matches yet.',
  /** Shown for a peer's futures while they stay hidden until the first kickoff. */
  FUTURES_HIDDEN_LABEL: 'Hidden until kickoff',
  /**
   * Your own profile outside the World Cup is read-only, so say where editing lives rather
   * than leaving a viewer tapping picks that will not respond.
   */
  SELF_READ_ONLY_HINT: 'This is how your squad sees you. Edit your picks on the Picks tab.',
  /**
   * Breakdown under the points chip while a match is in play (specs/champions-league AC-18.4).
   * The headline is the provisional total, which is what the squad board ranked by; this line
   * is what makes it explainable rather than merely larger, and it is also what reconciles the
   * global leaderboard, which deliberately keeps a settled headline (AC-18.8).
   */
  pointsBreakdown: (settled: number, live: number) => `${settled} settled · +${live} live`,
} as const

export const MEMBER_PROFILE_TEST_IDS = {
  points: 'member-profile-points',
  pointsBreakdown: 'member-profile-points-breakdown',
  /** The Winner square's kit overlay — present only for a club competition (AC-15.16). */
  winnerKit: 'member-profile-winner-kit',
} as const
